import httpService from "./httpService";
import { Location } from "../utils/types";

export const createLocation = async (location: Location) => httpService.post(`/locations`, location);


export const search = async (params?: any) => {
	const { data } = await httpService.get(`/locations/search`, { params });
	return data;
};

export const getLocation = async (id: string) => {
	const { data } = await httpService.get(`/locations/${id}`);
	return data;
};

export const deleteLocation = async (id: string | number) => {
	const { data } = await httpService.delete(`/locations/${id}`);
	return data;
};


const getURL = (text: string) =>
	`https://api.maptiler.com/geocoding/${encodeURIComponent(
		text.trim()
	)}.json?types=region%2Clocality&country=br&country=uy&proximity=ip&fuzzyMatch=true&limit=10&key=${
		process.env.REACT_APP_MAPTILER_API
	}`;

export const getExternalLocations = async (param) => {
	const response = await fetch(getURL(param), {
		method: "GET",
	});
	return await response.json();
};

export const getLocations = async (search: string) => {
	const { data } = await httpService.get(`/locations`, { search });
	return data;
};


export const updateLocation = async (location: any) => httpService.put(`/locations/${location.id}`, location);
